"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _InputConstants = require("./InputConstants");

var _FieldsetContext = require("../context/FieldsetContext");

var PLACEHOLDER = '__PLACEHOLDER__';

var renderOption = function renderOption(_ref) {
  var disabled = _ref.disabled,
      text = _ref.text,
      value = _ref.value,
      nestedOptions = _ref.options;
  return nestedOptions ? _react.default.createElement("optgroup", {
    disabled: disabled,
    key: text + value,
    label: text || value
  }, nestedOptions.map(renderOption)) : _react.default.createElement("option", {
    disabled: disabled,
    key: text + value,
    value: value
  }, text || value);
};

var UISelectInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UISelectInput, _Component);

  function UISelectInput() {
    (0, _classCallCheck2.default)(this, UISelectInput);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UISelectInput).apply(this, arguments));
  }

  (0, _createClass2.default)(UISelectInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "options", "placeholder", "disabled"]);
      var fieldSize = this.context.size;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('hs-custom-select', 'private-form__control', 'private-form__select', 'form-control', 'display-inline-block', _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], {
          'private-form__control--disabled': disabled
        }, className)
      }, _react.default.createElement("select", Object.assign({}, rest, {
        disabled: disabled
      }), placeholder && _react.default.createElement("option", {
        disabled: true,
        key: "placeholder",
        value: PLACEHOLDER
      }, placeholder), options.map(renderOption)));
    }
  }]);
  return UISelectInput;
}(_react.Component);

UISelectInput.contextType = _FieldsetContext.FieldsetContext;
UISelectInput.propTypes = {
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    text: _propTypes.default.string,
    value: _propTypes.default.any.isRequired
  }).isRequired).isRequired,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string
};
UISelectInput.defaultProps = {
  value: PLACEHOLDER
};
UISelectInput.displayName = 'UISelectInput';

var _default = (0, _Controllable.default)(UISelectInput);

exports.default = _default;
module.exports = exports.default;